import { createFileRoute } from "@tanstack/react-router";
import { CliProjectSelectionPage } from "@/components/cli-auth/project-selection-page";

export const Route = createFileRoute("/_app/cli-project-select/$sessionId")({
  component: () => <CliProjectSelectionPage />,
});
